import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { NgxMaskModule } from 'ngx-mask';
//import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ManageModulesComponent } from './components/modules/manage-modules.component';
import { AddNavigationItemComponent } from './components/modules/add-navigation-item.component';
import { ManageContactsComponent } from "../admin/components/contacts/manage-contacts.component";
import { ContactDetailsComponent } from "../admin/components/contacts/contact-details.component";
import { ContactService } from "../admin/services/contacts.service";
import { GroupService } from "../admin/services/group.service";
import { PermissionsService } from "../admin/services/permissions.service";
import { ManageGroupsComponent } from "../admin/components/groups/manage-groups.component";
import { GroupDetailsComponent } from "../admin/components/groups/group-details.component";
import { PermissionsSelector } from "../admin/components/groups/permissions-selector.component";
import { UserSelector } from "../admin/components/groups/user-selector.component";
import { LunaCommonModule } from '../common/common.module';
import { ADMIN_ROUTES } from './admin.routes';
import { ModuleGroupService } from '../common/services/modulegroup.service';
import { InternalGuardService } from '../auth/guards/internal-guard.service';
import { BaseGuardService } from '../auth/guards/base-guard.service';
import { AddLinkComponent } from './components/modules/add-link.component';
import { SystemPermissionGuardService } from '../auth/guards/system-permission-guard.service';
import { RemindersService } from "./services/reminders.service";

import { ReminderEditComponent } from './components/reminder-builder/reminder-edit/reminder-edit.component';
import { ReminderListComponent } from './components/reminder-builder/reminder-list/reminder-list.component';


import { OrganizationService } from '../common/services/organization.service';
import { FaInstrumentDetailsComponent } from './components/financial-assurance/fa-instrument-details.component';
import { ManageContactsResolver } from './Resolvers/manage-contacts.resolver';
import { FaInstrumentResolver } from './Resolvers/fa-instrument.resolver';
import { FaInsuranceResolver } from './Resolvers/fa-insurance.resolver';
import { FaInsuranceDetailsComponent } from './components/financial-assurance/fa-insurance-details.component';
import { CommunicationTemplatesComponent } from './components/communications/communication-templates.component';
import { CommunicationTemplateEditorComponent } from './components/communications/communication-template-editor.component';
import { ChiefOrdersComponent } from './components/chief-orders/chief-orders.component';
import { LunaDashboardModule } from '../dashboard/dashboard.module';
import { AccordionModule } from '../common/components/accordion/accordion.module';
import { DataTableModule } from '../common/components/data-table/data-table.module';
import { RICSMenuModule } from '../common/components/menu/menu.module';
import { ContactDetailComponent } from './components/contacts/contact-detail/contact-detail.component';
import { UtilityService } from './services/utility.service';
import { ContactNotesComponent } from './components/contacts/contact-notes/contact-notes.component';
import { CoLevelConfigComponent } from './chiefs-orders/co-level-config/co-level-config.component';
import { CoLevelMergeFieldsComponent } from './chiefs-orders/co-approval/co-level-mergefields/co-level-mergefields.component';
import { CoApproveLetterComponent } from './chiefs-orders/co-approval/co-approve-letter/co-approve-letter.component';
import { CommunicationGetOrg } from './Resolvers/communication-getorginfo.resolve';
import { CommunicationGetMergeFields } from './Resolvers/communication-getmergefields.resolve';
import { ChiefsOrderCoInProg } from './Resolvers/co-getcoinstance.resolve';
import { CoSubmitChiefsorderComponent } from './chiefs-orders/co-approval/co-submit-chiefsorder/co-submit-chiefsorder.component';
import { CoReviewChiefsorderComponent } from './chiefs-orders/co-approval/co-review-chiefsorder/co-review-chiefsorder.component';
import { IssueDetailsComponent } from './components/Issues/issue-details.component';
import { CoCancelComponent } from './chiefs-orders/co-approval/co-cancel/co-cancel.component';
import { CoReturnComponent } from './chiefs-orders/co-approval/co-return/co-return.component';
import { CoReviewLetterComponent } from './chiefs-orders/co-approval/co-edit-letter/co-edit-letter.component';
import { CoSignatureComponent } from './chiefs-orders/co-approval/co-signature/co-signature.component';
import { ChiefsOrderGetProfile } from './Resolvers/co-getprofile.resolve';
import { ChiefsOrderGetContactAuthority } from './Resolvers/co-getcontactbyauthority';
import { ChiefsOrderSignersList } from './Resolvers/co-getSignersList';
import { EDiscoveryRequestWrapperComponent } from './components/eDiscovery/request-wrapper/request-wrapper.component';
import { EDiscoverySearchResultsComponent } from './components/eDiscovery/search-results/search-results.component';
import { EDiscoveryService } from "./services/eDiscovery.service";
import { EDiscoveryNewRequestComponent } from './components/eDiscovery/new-request/new-request.component';
import { EDiscoveryRequestSearchComponent } from './components/eDiscovery/request-search/request-search.component';
import { EDiscoveryRequestDetailsComponent } from './components/eDiscovery/request-details/request-details.component';
import { DataCorrectionService } from '../services/dataCorrection.service';
import { DataCorrectionItemSelectorComponent } from './components/data-corrections/data-correction-item-selector.component';
import { DataCorrectionComponent } from './components/data-corrections/data-correction/data-correction.component';
import { ContactHistoryComponent } from './components/contacts/contact-history/contact-history.component';
import { AdminReportsService } from './services/admin-reports.service';
import { BondsReportComponent } from './components/financial-assurance-reports/bonds-report/bonds-report.component';
import { CertificateOfDepositReportComponent } from './components/financial-assurance-reports/certificateOfDeposits-report/certificate-of-deposit-report.component';
import { SurplusInsurerReportComponent } from './components/financial-assurance-reports/surplusInsurer-report/surplus-insurer-report.component';
import { ActiveOwnersReportComponent } from './components/financial-assurance-reports/activeOwners-report/active-owners-report.component';
import { ContactDeletionComponent } from './components/contacts/contact-deletion/contact-deletion.component';
import { WellTransferReportComponent } from './components/financial-assurance-reports/wellTransfer-report/well-transfer-report.component';
import { ContactHistoryReportComponent } from './components/reports/contact-history-report/contact-history-report.component';
import { RequestScanComponent } from './components/scanning/request-scan/request-scan.component';
import { ScanRequestService } from "./services/scan-request.service";
import { SubmitScanComponent } from './components/scanning/submit-scan/submit-scan.component';
import { ConfirmScanComponent } from './components/scanning/confirm-scan/confirm-scan.component';
import { OnBaseIntegrationAndMappingService } from '../common/services/onbase-integration-mapping.service';
import { OnBaseInterfaceConfigComponent } from './components/onbase-interface/onbase-interface-config/onbase-interface-config-component';
import { OnBaseInterfaceUploadComponent } from './components/onbase-interface/onbase-interface-upload/onbase-interface-upload-component';
import { OnBaseMappedKeywordInputComponent } from './components/onbase-interface/onbase-mapped-keyword-input/onbase-mapped-keyword-input.component';
import { OnBaseProgramAreaDocumentGroupSelector } from './components/onbase-interface/onbase-interface-config/onbase-program-area-group-selector';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { OnBaseFileUploadReportComponent } from './components/reports/onbase-file-upload-report/onbase-file-upload-report.component';
import { FailedWellTransferReportComponent } from './components/financial-assurance-reports/failed-well-transfer-report/failed-well-transfer-report.component';
import { LetterOfCreditTrackingComponent } from './components/financial-assurance-reports/letters-of-credit-report/letters-of-credit-report.component';
import { DataCorrectionInputComponent } from './components/data-corrections/data-correction-input/data-correction-input.component';
import { CoDetailsComponent } from './chiefs-orders/co-details/co-details.component';
import { InsuranceDateListingReportComponent } from './components/financial-assurance-reports/insurance-date-listing-report/insurance-date-listing-report.component';
import { CountyEngineersReportComponent } from './components/adhoc-reports/county-engineers-report/county-engineers-report.component';
import { GroupSelectorComponent } from './components/groups/group-selector.component';
import { AdhocReportsService } from './services/adhoc-reports-service';
import { ManageInspectorsComponent } from './components/manage-inspectors/manage-inspectors.component';
import { PermittingReportsComponent } from './components/powerbi-reports/permitting-reports/permitting-reports.component';
import { PermitApplicationsTrackingSummaryReportComponent } from './components/adhoc-reports/permit-applications-tracking-summary-report/permit-applications-tracking-summary-report.component';
import { PermitApplicationsReportComponent } from './components/adhoc-reports/permit-applications-report/permit-applications-report.component';
import { RegeneratePermitComponent } from './components/regenerate-permit/regenerate-permit.component';
import { UploadStatusComponent } from './components/regenerate-permit/upload-status/upload-status.component';
import { LetterMergeFieldsComponent } from './components/communications/letter-mergefields/letter-mergefields.component';
import { LetterCreationComponent } from './components/communications/letter-creation/letter-creation.component';
import { OnBaseQueueStatusComponent } from './components/reports/onbase-queue-status/onbase-queue-status.component';
import { SubmitPassthroughPermitComponent } from './components/landowner-passthrough/submit-passthrough-permit/submit-passthrough-permit.component';
import { CompleteProgramComponent } from './components/landowner-passthrough/complete-program/complete-program.component';
import { ViewPassthroughPermitsComponent } from './components/landowner-passthrough/view-passthrough-permits/view-passthrough-permits.component';
import { SchematicsPreviewComponent } from './components/regenerate-permit/schematics-preview/schematics-preview.component';
import { ReserveApiComponent } from './components/reserve-api/reserve-api.component';
import { ReservationNotesComponent } from './components/reserve-api/reservation-notes/reservation-notes.component';
import { RegenerateInvoiceReceiptComponent } from './components/regenerate-invoice-receipt/regenerate-invoice-receipt.component';
import { PermitApplicationsDetailedReportComponent } from './components/adhoc-reports/permit-applications-detailed-report/permit-applications-detailed-report.component';
import { ApplicationLogComponent } from './components/reports/application-log/application-log.component';
import { SubmitBulkWellUpdateComponent } from './components/bulk-well-update/submit-bulk-well-update/submit-bulk-well-update.component';
import { ApproveBulkWellUpdateComponent } from './components/bulk-well-update/approve-bulk-well-update/approve-bulk-well-update.component';
import { InsuranceFullDataListComponent } from './components/reports/insurance-full-data-list/insurance-full-data-list.component';
import { InsuranceComplianceByDateReportComponent } from './components/reports/insurance-compliance-by-date-report/insurance-compliance-by-date-report.component';
import { LandownerWrapperComponent } from './components/landowner-passthrough/landowner-wrapper/landowner-wrapper.component';
import { EditLandownerApplicationComponent } from './components/landowner-passthrough/edit-landowner-application/edit-landowner-application.component';
import { LandownerApplicationResolver } from "./Resolvers/landowner-application.resolver";
import { ReviewLandownerApplicationComponent } from './components/landowner-passthrough/review-landowner-application/review-landowner-application.component';
import { DisplayNoteComponent } from './components/landowner-passthrough/display-note/display-note.component';
import { ProgramTimelineComponent } from './components/landowner-passthrough/program-timeline/program-timeline.component';
import { ProgramNotesComponent } from './components/landowner-passthrough/program-notes/program-notes.component';
import { UserPermissionsReportComponent } from './components/reports/user-permissions-report/user-permissions-report.component';
import { StratigraphicWellsReportComponent } from './components/adhoc-reports/stratigraphic-wells-report/stratigraphic-wells-report.component';
import { ComplianceReportComponent } from './components/reports/compliance-report/compliance-report.component';
import { SystemSettingsService } from "./services/system-settings.service";
import { SystemSettingsComponent } from './components/system-settings/system-settings.component';
import { SystemAlertsComponent } from './components/system-alerts/system-alerts.component';
import { EditSystemAlertComponent } from './components/system-alerts/edit-system-alert/edit-system-alert.component';
import { CreateSystemAlertComponent } from './components/system-alerts/create-system-alert/create-system-alert.component';
import { DeleteApiComponent } from './components/delete-api/delete-api.component';
import { UploadNad83UpdatesComponent } from './components/bulk-nad83/upload-nad83-updates/upload-nad83-updates.component';
import { ApproveNad83UpdatesComponent } from './components/bulk-nad83/approve-nad83-updates/approve-nad83-updates.component';
import { NAD83ReadonlyComponent } from './components/bulk-nad83/nad83-readonly/nad83-readonly.component';
import { ManageFeesComponent } from './components/manage-fees/manage-fees.component';
import { FeeEditorComponent } from './components/manage-fees/fee-editor/fee-editor.component';
import { BondingReceivedReportComponent } from './components/financial-assurance-reports/bonding-received-report/bonding-received-report.component';
import { CollateralReleasedReportComponent } from './components/financial-assurance-reports/collateral-released-report/collateral-released-report.component';

@NgModule({
    imports: [
        CommonModule,
        LunaDashboardModule,
        FormsModule,
        AccordionModule,
        LunaCommonModule,
        RICSMenuModule,
        DataTableModule,
        ReactiveFormsModule,
        RouterModule.forChild(ADMIN_ROUTES),
        NgxMaskModule.forRoot(),
        NgxExtendedPdfViewerModule,
        NgSelectModule,
    ],
    providers: [
        BaseGuardService,
        ContactService,
        GroupService,
        InternalGuardService,
        PermissionsService,
        ModuleGroupService,
        RemindersService,
        SystemPermissionGuardService,
        OrganizationService,
        ManageContactsResolver,
        FaInstrumentResolver,
        FaInsuranceResolver,
        UtilityService,
        CommunicationGetOrg,
        CommunicationGetMergeFields,
        ChiefsOrderCoInProg,
        ChiefsOrderGetProfile,
        ChiefsOrderGetContactAuthority,
        ChiefsOrderSignersList,
        EDiscoveryService,
        DataCorrectionService,
        AdminReportsService,
        ScanRequestService,
        OnBaseIntegrationAndMappingService,
        AdhocReportsService,
        LetterMergeFieldsComponent,
        LetterCreationComponent,
		LandownerApplicationResolver,
		SystemSettingsService
    ],
    declarations: [
        AddNavigationItemComponent,
        ManageModulesComponent,
        ManageContactsComponent,
        ContactDetailsComponent,
        ContactHistoryComponent,
        ManageGroupsComponent,
        GroupDetailsComponent,
        PermissionsSelector,
        UserSelector,
        AddLinkComponent,
        ReminderEditComponent,
        ReminderListComponent,
        FaInstrumentDetailsComponent,
        FaInsuranceDetailsComponent,
        CommunicationTemplatesComponent,
        CommunicationTemplateEditorComponent,
        ChiefOrdersComponent,
        ContactDetailComponent,
        ContactNotesComponent,
        CoLevelConfigComponent,
        CoLevelMergeFieldsComponent,
        CoApproveLetterComponent,
        CoSubmitChiefsorderComponent,
        CoReviewChiefsorderComponent,
        CoDetailsComponent,
        IssueDetailsComponent,
        CoCancelComponent,
        CoReturnComponent,
        CoReviewLetterComponent,
        CoSignatureComponent,
        EDiscoveryRequestWrapperComponent,
        EDiscoverySearchResultsComponent,
        EDiscoveryNewRequestComponent,
        EDiscoveryRequestSearchComponent,
        EDiscoveryRequestDetailsComponent,
        DataCorrectionItemSelectorComponent,
        DataCorrectionComponent,
        DataCorrectionInputComponent,
        BondsReportComponent,
        CertificateOfDepositReportComponent,
        SurplusInsurerReportComponent,
        ActiveOwnersReportComponent,
        ContactDeletionComponent,
        WellTransferReportComponent,
        ContactHistoryReportComponent,
        OnBaseFileUploadReportComponent,
        RequestScanComponent,
        SubmitScanComponent,
        ConfirmScanComponent,
        OnBaseInterfaceConfigComponent,
        OnBaseInterfaceUploadComponent,
        OnBaseMappedKeywordInputComponent,
        OnBaseProgramAreaDocumentGroupSelector,
        FailedWellTransferReportComponent,
        LetterOfCreditTrackingComponent,
        InsuranceDateListingReportComponent,
        CountyEngineersReportComponent,
        GroupSelectorComponent,
        ManageInspectorsComponent,
        PermitApplicationsTrackingSummaryReportComponent,
        PermittingReportsComponent,
        PermitApplicationsReportComponent,
		RegeneratePermitComponent,
        UploadStatusComponent,
        LetterMergeFieldsComponent,
        LetterCreationComponent,
        OnBaseQueueStatusComponent,
        SubmitPassthroughPermitComponent,
        CompleteProgramComponent,
        ViewPassthroughPermitsComponent,
        SchematicsPreviewComponent,
        ReserveApiComponent,
        ReservationNotesComponent,
        RegenerateInvoiceReceiptComponent,
        PermitApplicationsDetailedReportComponent,
        ApplicationLogComponent,
        SubmitBulkWellUpdateComponent,
        ApproveBulkWellUpdateComponent,
        InsuranceFullDataListComponent,
        InsuranceComplianceByDateReportComponent,
        LandownerWrapperComponent,
        EditLandownerApplicationComponent,
        ReviewLandownerApplicationComponent,
        DisplayNoteComponent,
        ProgramTimelineComponent,
        ProgramNotesComponent,
        UserPermissionsReportComponent,
        StratigraphicWellsReportComponent,
        SystemSettingsComponent,
        ComplianceReportComponent,
        SystemAlertsComponent,
        EditSystemAlertComponent,
        CreateSystemAlertComponent,
        DeleteApiComponent,
        UploadNad83UpdatesComponent,
        ApproveNad83UpdatesComponent,
		NAD83ReadonlyComponent,
		ManageFeesComponent,
		FeeEditorComponent,
		BondingReceivedReportComponent,
		CollateralReleasedReportComponent
    ],
    exports: [
        ContactNotesComponent,
        ContactHistoryComponent
    ]
})
export class LunaAdminModule { }
